// @flow
import { DISMISS_ALERT, DISMISS_ALL_ALERTS, REQUEST_ALERT } from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const actionHandlers = {
    [DISMISS_ALERT]: handleReduce((state, { payload: id }) =>
        // $FlowFixMe
        state.update('alertItems', alerts => alerts.filter(a => a.get('id') !== id))
    ),
    // $FlowFixMe
    [DISMISS_ALL_ALERTS]: handleReduce(state => state.set('alertItems', fromJS([]))),
    [REQUEST_ALERT]: handleReduce((state, { payload }) =>
        // $FlowFixMe
        state.update('alertItems', alerts => {
            return alerts
                .filter(x => x.get('type') !== payload.type && x.getIn(['text', 'id']) !== payload.text.id)
                .push(fromJS(payload));
        })
    )
};

export default handleActions(actionHandlers, fromJS({ alertItems: [] }));



// WEBPACK FOOTER //
// ./src/core/state/alerts/index.js